module.exports = __webpack_public_path__ + "img/background.4de9135b.jpg";